export default __webpack_public_path__ + "static/media/Blanco.86ba11c5.png";